export default __webpack_public_path__ + "static/media/ConstruyendoElFuturo_bannerMAIL.d237f7bf.jpg";